import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useHotelAdminStore } from '../store'

export default function AdminVerifyEmailSentPage() {
  const navigate = useNavigate()
  const admin = useHotelAdminStore((state) => state.admin)

  useEffect(() => {
    // Auto-redirect after 5 seconds or if user clicks the link
    const timer = setTimeout(() => {
      navigate('/admin-subscription-select')
    }, 5000)

    return () => clearTimeout(timer)
  }, [navigate])

  if (!admin?.email) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-indigo-600 to-blue-600 p-4">
        <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-8 text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Ошибка</h2>
          <p className="text-gray-600 mb-6">Данные админа не найдены. Пожалуйста, зарегистрируйтесь заново.</p>
          <button
            onClick={() => navigate('/admin-login')}
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 rounded-lg"
          >
            Вернуться на вход
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-indigo-600 to-blue-600 p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-lg shadow-lg p-8 text-center">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-800">🏨 HotelsProd</h1>
            <h2 className="text-xl font-semibold text-gray-600 mt-2">Подтверждение email</h2>
          </div>

          <div className="py-8">
            <div className="text-5xl mb-6">📧</div>
            <h3 className="text-2xl font-bold text-gray-800 mb-3">Проверьте вашу почту</h3>
            <p className="text-gray-600 mb-3">
              Мы отправили письмо с ссылкой для подтверждения на:
            </p>
            <p className="text-lg font-semibold text-indigo-600 mb-6">
              {admin.email}
            </p>
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 text-sm text-blue-800">
              <p className="font-semibold mb-2">📌 Инструкции:</p>
              <ul className="list-disc list-inside space-y-1">
                <li>Откройте письмо в вашей почте</li>
                <li>Нажмите кнопку "Подтвердить email"</li>
                <li>Или перейдите по ссылке в письме</li>
                <li>Ссылка действительна 24 часа</li>
              </ul>
            </div>

            <p className="text-sm text-gray-500 mb-6">
              Не получили письмо? Проверьте папку спама или<br/>
              свяжитесь с поддержкой.
            </p>

            <div className="space-y-3">
              <button
                onClick={() => navigate('/admin-subscription-select')}
                className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 rounded-lg transition"
              >
                Я уже подтвердил email
              </button>
              <button
                onClick={() => navigate('/admin-login')}
                className="w-full bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 rounded-lg transition"
              >
                Назад на вход
              </button>
            </div>

            <p className="text-xs text-gray-400 mt-6">
              Перенаправление через 5 секунд...
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
